import { config } from '../config';

import gtagEvent from './gtagEvent';

// A manager's outreach link (`viads.com/?mref=123.<signature>`, or straight to
// `/signup?mref=…`, issued by `php artisan manager:outreach-link` in
// adplay-api) leaves this cookie on the root domain. Sign-up and sign-in send
// it to the API as `manager_ref`; the API verifies the signature and attaches
// the manager. The landing (viads.com repo) writes the same cookie.
const COOKIE = 'viads_manager_ref';
const PARAM = 'mref';
const MAX_AGE_SECONDS = 90 * 24 * 60 * 60;
const TOKEN = '(\\d+)\\.[A-Za-z0-9_-]+';

const domainAttr = () =>
  window.location.hostname.endsWith(config.ROOT_DOMAIN)
    ? `; domain=.${config.ROOT_DOMAIN}`
    : '';

const writeCookie = (value: string, maxAge: number) => {
  document.cookie = `${COOKIE}=${value}; max-age=${maxAge}; path=/${domainAttr()}; samesite=lax`;
};

const readToken = () =>
  document.cookie.match(new RegExp(`(?:^|; )${COOKIE}=(${TOKEN})(?:;|$)`));

export const getManagerRef = (): string | undefined => readToken()?.[1];

export const captureManagerFromUrl = () => {
  const token = new URLSearchParams(window.location.search).get(PARAM);
  const match = token?.match(new RegExp(`^${TOKEN}$`));

  if (!token || !match) return;

  writeCookie(token, MAX_AGE_SECONDS);
  gtagEvent('event', 'manager_link_click', { manager_id: match[1] });
};

/** Report the attributed sign-up or sign-in once, then forget the manager. */
export const completeManagerAttribution = (
  event: 'manager_link_signup' | 'manager_link_login'
) => {
  const managerId = readToken()?.[2];

  if (managerId === undefined) return;

  gtagEvent('event', event, { manager_id: managerId });
  writeCookie('', 0);
};
